(function() {
    'use strict';

    angular.module('appliances', [
            'ui.router',

            'appliances.constants',
            'appliances.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'appliancesPermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, appliancesPermissionsConst) {
        $stateProvider
            .state('layout.appliances', {
                abstract: true,
                url: '/appliances',
                data: {
                    title: 'Zastosowania',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.appliances.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/appliances/views/appliances-list/appliances-list.html',
                        controller: 'AppliancesListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: appliancesPermissionsConst.view
                }
            })
            .state('layout.appliances.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/appliances/views/appliances-create/appliances-create.html',
                        controller: 'AppliancesCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: appliancesPermissionsConst.add
                }
            })
            .state('layout.appliances.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/appliances/views/appliances-update/appliances-update.html',
                        controller: 'AppliancesUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: appliancesPermissionsConst.update
                }
            });
    }
})();
